@if (showReasonText()) {
  <app-icon-button-dialog
    [icon]="reasonIcon()"
    header="provider.tenders.phases.reasonText"
    [colorClass]="colorClass()"
    [disabled]="!hasReasonText()"
    dialogStyleClass="icon-button-middle"
  >
    <p-card class="w-full text-left">
      <div class="card bg-third-level">
        {{ phaseStatusInfo().phaseDecisionReason }}
      </div>
    </p-card>
  </app-icon-button-dialog>
} @else {
  <div class="w-8 h-8"></div>
}
